
import { REHYDRATE } from 'redux-persist';
import { constants } from '../constants/redux-constants'

const initialState = {
  task: {},
};

const Tasksreducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...state,
        ...action.payload?.tasks || {}
      };
    case constants.RESET:
      return {
        ...initialState
      }
    case constants.TASKS.TASK_DETAILS:
      return {
        ...state,
        task: action.payload,
      };
    default:
      return {
        ...state
      }
  }
};

export default Tasksreducer;

